import React from 'react';
import s from './BrandAnalyticsPage.module.css';
import Header from '../start-page/Header';
import Banner from './Banner';
import CtaSection from '../start-page/CtaSection';
import Footer from '../start-page/Footer';
import HeroSection from './HeroSection';
import DescribeSection from './DescribeSection';
import TextSection from './TextSection';
const BrandAnalyticsPage: React.FC = () => {
    return (
        <div className={s.container}>
            <Header />
            <Banner />
            <HeroSection />
            <DescribeSection />
            <TextSection />
            <CtaSection />
            <Footer />
        </div>
    );
};

export default BrandAnalyticsPage;
